export default {
    "global": {
        "instructions": "Mode d'emploi",
        "active": "Actif",
        "action": "Action",
        "actions": "Actions",
        "add": "Ajouter",
        "addkeyword": "Ajouter un mot clé",
        "addkeywords": "Ajout de Mots clés",
        "addsource": "Ajouter une source",
        "all": "Tous",
        "amount": "Montant",
        "anchor": "Ancre",
        "apply": "Appliquer",
        "article": "Article",
        "audit": "Audit",
        "available": "Disponible",
        "back": "Retour",
        "brief": "Brief",
        "brief_partenaire": "Brief Partenaire",
        "budget": "Budget",
        "bulkedit": "Action en masse",
        "cancel": "Annuler",
        "category": "Catégorie",
        "categories": "Catégories",
        "choose": "Choisir",
        "client": "Client",
        "close": "Fermer",
        "columns": "Colonnes",
        "content": "Contenu",
        "copied": "Copié",
        "copy": "Copier",
        "created-at": "Date de création",
        "credits": "Crédits",
        "current-month": "Mois en cours",
        "delete": "Supprimer",
        "deleteConfirmation": "Êtes vous sûr ?",
        "deleteConfirmationDesc": "Cette opération est irréversible",
        "deleteYes": "Oui, supprimer",
        "desactivate": "Désactiver",
        "inactive": "Inactif",
        "disconnect": "Déconnexion",
        "details": "Détails",
        "domain": "Domaine",
        "done": "Fait",
        "download": "Télécharger",
        "earnings": "Gains",
        "edit": "Editer",
        "elementbypage": "éléments par page",
        "email": "Email",
        "error": "Erreur",
        "error-url": "L'URL semble incorrect",
        "errors": "Erreurs",
        "event": "Évènement",
        "export": "Exporter",
        "filter": "Filtrer",
        "filters": "Filtres",
        "here": "Ici",
        "hi": "Bonjour",
        "hide": "Masquer",
        "importantinformations": "Informations importantes",
        "included": "inclus",
        "invoicing": "Facturation",
        "keyword": "Mot clé",
        "keywords": "Mots clés",
        "lastscrap": "Dernier scrap",
        "legalnotice": "Mentions légales",
        "link": "Lien",
        "loading": "Chargement",
        "locale": "Langue",
        "maxprice": "Prix max.",
        "minprice": "Prix min.",
        "message": "Message",
        "modify": "Modifier",
        "move": "Déplacer",
        "moveproject": "Déplacer vers le projet",
        "moovetoproject": "Déplacer vers un projet",
        "month": "Mois",
        "new": "Nouveau",
        "next": "Suivant",
        "no": "Non",
        "none": "Aucun",
        "note": "Note",
        "options": "Options",
        "or": "ou",
        "order": "Commander",
        "orders": "Commandes",
        "preorders": "Précommandes",
        "other": "Autre",
        "page": "Page",
        "payment": "Paiement",
        "payByCB": "Payer par CB",
        "payByWireTransfer": "Payer par virement",
        "per-page": "Résultats par page",
        "prev": "Précédent",
        "price": "Prix",
        "priority": "Priorité",
        "project": "Projet",
        "quantity": "Volume",
        "health": "Santé",
        "activate": "Activer",
        "reactivate": "Réactiver",
        "reason": "Motif",
        "recipient": "Destinataire",
        "redaction": "Rédaction",
        "ref": "Réf.",
        "reinitialize": "Réinitialiser",
        "research": "Rechercher",
        "save": "Enregistrer",
        "show-search": "Afficher les champs de recherche",
        "send": "Envoyer",
        "selectStatus": "Sélectionner un statut",
        "site": "Site",
        "sitesale": "Vente de site",
        "sites": "Sites",
        "sites-types": {
            "gold": "Or",
            "silver": "Argent",
            "bronze": "Bronze",
            "vip": "VIP Or",
            "unknown": "Inconnu"
        },
        "sorry": "Désolé",
        "source": "Source",
        "stats": "Statistiques",
        "status": "Statut",
        "stop": "Arrêter",
        "success": "L'action a été effectuée avec succès",
        "tag": "Tag",
        "thankyou": "Merci",
        "time": {
            "date": "Date",
            "duration": "Durée",
            "month": "mois",
            "months": "mois",
            "period": "Période",
            "year": "an"
        },
        "todo": "A faire",
        "todelete": "A supprimer",
        "tovalidate": "A valider",
        "theme": "Thématique",
        "update": "Mettre à jour",
        "use": "Utiliser",
        "validate": "Valider",
        "verification": "Vérification",
        "words": "Mots",
        "yes": "Oui",
        "new-error": "Une erreur est survenue",
        "url": "URL",
        "url-extension": "Extension de l'URL",
        "show": "Voir",
        "partner": "Partenaire"
    },
    "error": {
        "message": {
            "default": "Une erreur s'est produite",
            "server": "Erreur serveur",
            "validation": "Erreur : données invalides"
        }
    },
    "campaign": {
        "new": "Nouvel accompagnement"
    },
    "language": {
        "title": "Langue",
        "French": "Français",
        "English": "Anglais"
    },
    "user": {
        "email": "Email",
        "internet_bs_email": "Email internet.bs",
        "firstname": "Prénom",
        "lastname": "Nom",
        "company": "Société",
        "address": "Adresse",
        "postal-code": "Code postal",
        "city": "Ville",
        "country": "Pays",
        "phone": "Téléphone",
        "api_key": "Clé API",
        "TVAnumber": "Numéro de TVA",
        "noTVA": "Exonérée de TVA",
        "nosiretnumber": "Je n'ai pas de numéro SIRET",
        "siret": "SIRET",
        "attestation_siret": "Attestation SIRET",
        "attestation": {
            "attestation": "Attestation",
            "last_attestation_status": "Dernière Att.",
            "type": "Type d'attestation",
            "urssaf": "URSSAF (À privilégier, Gratuit)",
            "urssaf_required": "URSSAF (obligatoire)",
            "kbis": "Extrait de KBIS (Payant)",
            "insee": "Insee (Création d'entreprise récente)",
            "warning": "Document de moins de 6 mois",
            "others": "Autres"
        },
        "payment": {
            "accountnumber": "N° compte",
            "bank": "Banque",
            "bankaccountowner": "Titulaire du compte",
            "bankadress": "Adresse bancaire",
            "bankdepot": "Guichet",
            "bankname": "Nom de la banque",
            "key": "Clé",
            "mode": "Mode de paiement",
            "paypaladress": "Adresse Paypal",
            "paypal-fees": "Attention les frais bancaires Paypal seront à votre charge",
            "rib": "RIB",
            "save": "Sauvegarder mes informations comme moyen de paiement par défaut",
            "transfer": "Virement bancaire",
            "validIBAN": "Merci d'entrer un IBAN valide."
        }
    },
    "users": {
        "modify": "Modifier un utilisateur"
    },
    "links&anchors": {
        "link": "Lien article",
        "link&anchor": "Lien & ancre",
        "nolinksto": "Ne contenant pas de lien vers",
        "pageanchors": "Ancres de la page",
        "targetlink": "Lien cible",
        "targetlink2": "Lien cible 2",
        "wantedlink": "Lien demandé",
        "wantedlink2": "Lien 2 demandé",
        "wantedanchor2": "Ancre 2 demandée",
        "wantedlinks": " Lien(s) demandé(s)",
        "wantedanchor": "Ancre demandée",
        "wantedanchors": "Ancre(s) demandée(s)"
    },
    "suivi-admin": {
        "title": "Commandes",
        "expired-orders": "Suivre les commandes expirées"
    },
    "domain-posting": {
        "title": "Sites dispo / utilisateur"
    },
    "status": {
        "accepted": "Accepté",
        "activated": "Activé",
        "activated-s": "Activés",
        "attentevalidation": "En attente de validation",
        "attentecustomer": "En attente de retour client",
        "canceled": "Annulé",
        "canceled-s": "Annulés",
        "deleted": "Supprimé",
        "deactivated": "Désactivé",
        "desactivated-s": "Désactivés",
        "expired": "Expiré",
        "finished": "Terminé",
        "publication": "En cours de publication",
        "published": "Publié",
        "published-s": "Publiés",
        "redaction": "En cours de rédaction",
        "refused": "Refusé",
        "refused-s": "Refusés",
        "running": "En cours",
        "stopped-(es)": "Arrêtées",
        "supressed-s": "Supprimés",
        "validated": "Validé",
        "validated-es": "Validées",
        "waitingforvalidation": "En attente d'acceptation",
        "waitingforimprove": "En attente d'amélioration"
    },
    "achat-credits": {
        "alert-transfer": "Lors de la réalisation du virement : Merci d'indiquer la référence de la facture que vous allez recevoir par mail en référence de votre virement.",
        "amount": "€ HT, votre paiement sera donc de ",
        "creditgain": "% de crédits en plus",
        "minimumamount": "Merci d'entrer un montant entier supérieur ou égal à  ",
        "payment-card": "Paiement par carte",
        "payment-transfer": "Paiement par virement",
        "payment-transfer-preference": "Vous préferez payer par virement ?",
        "payment-transferdescription": "Les crédits seront ajoutés sur la plateforme à réception du virement. Vous trouverez ci-dessous les coordonnées bancaires à utiliser",
        "promocode": "Utilisation d'un coupon (facultatif)",
        "promocodeenter": "Vous avez un code promo",
        "promocodenotvalid": "Le code saisie n'est pas valide",
        "promocodeuse": "Vous allez utiliser le coupon ",
        "promocodeused": "Vous avez déjà profité de ce coupon",
        "save": "Enregistrer les informations",
        "sorry": "Désolé",
        "thatbeing": "soit ",
        "title": "Acheter des crédits",
        "subtitle": "Profitez de Nextlevel",
        "validation": "En validant, je m'engage à réaliser le virement bancaire de",
        "validation_02": "Les crédits seront ajoutés sur la plateforme à réception.",
        "wantedamount": "Entrez le crédit désiré",
        "recap": "Récapitulatif",
        "payment-methods": "Moyens de paiement : Carte Bancaire, Virement",
        "apply": "Appliquer",
        "additional-info": "Une information supplémentaire ?",
        "useful-reference": "Merci de renseigner toute référence utile",
        "amount-title": "Montant",
        "designation-title": "Désignation"
    },
    "achat-lien": {
        "restrictions": "Attention, le partenaire a mis en place les restrictions suivantes",
        "onelink": "Un seul lien possible",
        "max": "est le nombre maximum de mots que le partenaire accepte d'ajouter à son contenu",
        "anchors": "Seuls les ancres URLs ou mots génériques (cliquez ici, en savoir plus, etc) sont acceptées",
        "genericanchors": "Seuls les ancres URLs, mots génériques (cliquez ici, en savoir plus, etc) ou non optimisées (mots clés compris dans une phrase, etc) sont acceptées",
        "plannedpublication": "La planification n'est pas possible",
        "noMFA": "N'accepte pas les MFA concurrents"
    },
    "alertes": {
        "add": "Ajouter une alerte",
        "min": "Minimum",
        "title": "Alertes",
        "searchquantity": "Volume",
        "setalert": "Ajouter une alerte",
        "wantedquantity": "Volume souhaité",
        "updatealert": "Modifier une alerte"
    },
    "alertes-partenaires": {
        "addparent": "Ajouter toutes les catégories parentes",
        "addchild": "Ajouter toutes les catégories enfants",
        "alertpartner": "Ajouter une alerte partenaire",
        "categoryalert": "Catégorie Alerte",
        "daily": "Quotidienne",
        "emptylist": "Vider la liste des catégories",
        "frequency": "Fréquence",
        "getkeywords": "Recevoir les mots clés sans partenaires intéressés",
        "getalerts": "Recevoir les alertes des 2 mois précédents",
        "libelle": "Libellé (exemple: Alerte généraliste)",
        "modifyalert": "Modifier une alerte",
        "monthly": "Mensuelle",
        "multipleselect": "Catégorie alerte (sélection multiple)",
        "nointerested": "Aucun Intéressé",
        "title": "Mes alertes partenaires",
        "text": "Libellé",
        "weekly": "Hebdomadaire"
    },
    "buylink": {
        "about": "A propos de votre commande sur le mot clé",
        "buylink": "Achat lien",
        "credits": "crédits - Site",
        "incorectprice": "Le prix n'est pas bon",
        "impossible": "ACHAT IMPOSSIBLE : Vous avez déjà acheté un lien sur ce même domaine",
        "linkprice": "Vous avez acheté le lien pour",
        "notenoughtcredit": "Vous n'avez pas assez de credit",
        "thanks": "Merci pour votre achat!",
        "unavailablelink": "Le lien n'est plus disponible"
    },
    "campaign-manager": {
        "notification": {
            "budget": {
                "extendError": "Une erreur s'est produite, impossible d'étendre l'accompagnement",
                "extendValidation": "Votre accompagnement a bien été étendu de {duration} mois",
                "resetError": "Une erreur s'est produite, impossible de réinitialiser la répartition du budget",
                "resetValidation": "La répartition du budget a bien été réinitialisée",
                "createError": "Une erreur s'est produite, impossible de créer la répartition du budget",
                "createValidation": "La répartition du budget a bien été créée",
                "resetDialogTitle": "Réinitialiser la répartition du budget",
                "resetDialogMessage": "Voulez-vous remettre à zéro le tableau des répartitions sur la base des informations saisies ?"
            }
        }
    },
    "commande": {
        "back": "Retour aux précommandes",
        "addkeyword": "Ajouter un mot clé",
        "addnote": "Note au rédacteur",
        "available": "dispo",
        "brief": "Brief",
        "clickhere": " en cliquant ici",
        "contact": "Nous vous contacterons très rapidement afin de vous tenir au courant de l'évolution de votre précommande",
        "keyword": "Exemple : Croisière - 30 caractères max",
        "maincategory": "Catégorie Principale",
        "mainkeyword": "Mot-clé principal",
        "noproject": "Aucun projet trouvé. Pour passer une précommande, vous devez créer un projet",
        "notsaved": "Cette ligne n'est pas sauvegardée",
        "numberarticles": "Nombre d'articles souhaités",
        "preorder": "Précommande d'articles",
        "preorderAction": "Je précommande mes articles",
        "preorderarticles": "Précommander des articles",
        "remainingpreorders": "Il reste {remainingPreorders} précommande(s) possible(s) pour ce projet.",
        "secondarykeyword": "Mots-clés secondaires",
        "secondarykeyworddescription": "Mettez ici les mots-clés connexes au mot-clé principal. Les partenaires vous proposeront plus facilement des résultats pertinents sur ces mots-clés secondaires.",
        "secondarykeywords": "Mots-clés secondaires",
        "secondarykeywordempty": "Un mot clé vide ne sera pas pris en compte",
        "secondarykeywordexample": "Mot clé secondaire 1 (Exemple : Croisière Caraibes)",
        "toomany": "Quota dépassé. Veuillez supprimer des précommandes pour ce projet",
        "manageProjects": "Gestion des projets",
        "goToProject": " en cliquant ici",
        "validation": {
            "front": {
                "name": "Nom",
                "articlenumber": "Nombre d'articles",
                "alreadyinlist": "Le mot clé est déjà dans la liste",
                "empty": "{field} est vide",
                "issameasmain": "Le mot clé secondaire ne peut pas être identique au mot clé principal",
                "secondarykeyworderror": "Merci de vérifier si votre mot-clé secondaire ne contient pas d'erreur",
                "saved": "Sauvegarde effectuée",
                "saveddetails": "Les données ont été sauvegardées avec succès. Vous pouvez quittez la page sans risque",
                "low": " est trop bas"
            }
        }
    },
    "detail-accompagnement": {
        "title": "Détail Accompagnement "
    },
    "devenir-partenaire": {
        "advantages": "Une fois votre site validé, vous n’avez plus rien à faire jusqu’à l’avertissement par mail qu’une commande concerne un de vos sites",
        "advantages_02": "Vous recevez un pourcentage du prix total HT de la commande réalisée",
        "advantages_04": "Ces pourcentages sont précisés dans les CGV",
        "advantages_05": "Ensuite, soit vous pourrez retirer vos gains, soit vous pourrez les convertir en crédits NextLevel.link",
        "advantagestitle": "QUELS AVANTAGES POUR MOI ?",
        "contact": "Merci d'indiquer un moyen de vous joindre si nécessaire (au choix, téléphone ou Skype) pour le traitement de vos futures commandes.",
        "cgv": "J'accepte les CGV*",
        "descriptiontitle": "COMMENT ÇA MARCHE ?",
        "description": "Vous ajoutez votre site au service NextLevel.link. Lorsqu’un utilisateur fera une recherche, NextLevel.link. affichent tous les mots clés correspondants positionnés par l’ensemble des sites (nos sites ainsi que les sites partenaires).",
        "description_02": "Si une commande concerne un site partenaire, alors celui-ci reçoit un mail l'invitant à accepter ou refuser la commande sur son espace. Le détail de la commande est alors fournit sur son espace (Brief, nombre de mots supplémentaire...).Après rédaction de la commande, le partenaire n'aura plus qu'a venir valider celle-ci sur son espace.",
        "description_03": "Le partenaire dispose de 10 jours ouvrés pour réaliser la commande, et s’engage à respecter le contrat pour 24 mois au moins. Un contrôle est effectué par NextLevel.link<",
        "partsite": "C’est possible ! Lors de l’inscription d’un site, vous avez plusieurs possibilités.",
        "partsite_02": "Indiquer que seules les urls d’un sitemap sont autorisées, ce qui vous permet par exemple d’autoriser uniquement vos articles de blogs, et pas vos pages ou catégories, ou tags.",
        "partsite_03": "Via un fichier txt, vous pouvez aussi interdire une liste d’urls à NextLevel.link.",
        "partsitetitle": "JE NE SOUHAITE PAS SOUMETTRE MON SITE ENTIEREMENT",
        "title": "Devenir partenaire",
        "partneryes": "Oui, je souhaite devenir partenaire NextLevel.link",
        "redaction": "Pour chaque site ajouté, vous indiquez si vous souhaitez rédiger les contenus ou si vous confiez cette rédaction à NextLevel.link.",
        "redaction_02": "Ainsi, vous pouvez respecter votre ligne éditoriale ou bien faire le choix de ne vous occuper de rien, sauf la publication du texte fourni.",
        "redactiontitle": "NOUS REDIGEONS OU VOUS REDIGEZ, VOUS CHOISISSEZ",
        "sitetype": "Nous acceptons les sites Wordpress ainsi que les autres CMS.",
        "sitetype_02": "La validation de chaque site est réalisée manuellement. Nous observons votre site et nous nous gardons le droit de le refuser si la qualité ne nous semble pas suffisante.",
        "sitetype_03": "Toutes les thématiques sont acceptées, les sites devant respecter les lois en vigueur.",
        "sitetypetitle": "QUEL TYPE DE SITE ACCEPTEZ VOUS ?",
        "welcome": "L’équipe NextLevel.link vous souhaite la bienvenue "
    },
    "emails": {
        "assist": "Si vous rencontrez des problèmes pour la publication, n'hésitez pas à nous contacter sur le chat assistance du site ou par mail",
        "bestregards": "Bien cordialement,",
        "brief": "Pour le brief, rendez-vous ici",
        "content_size": "Le contenu à rédiger est de",
        "hi": "Bonjour",
        "nextlevelteam": "l'équipe NextLevel.link",
        "order_summary": "Rappel de la commande",
        "planneddate": "Date de publication souhaitée",
        "pleasesdontpublishbefore": "merci de ne pas publier avant cette date",
        "publishbefore": "Nous vous remercions de publier le contenu correspondant avant le",
        "redaction_you": "C'est vous qui vous chargez de la rédaction",
        "redaction_us": "Nous nous chargeons de sa rédaction",
        "redaction_us_quick": "Nous nous chargeons de sa rédaction et vous l'enverrons le plus rapidement possible",
        "seeyousoon": "A très vite sur Nextlevel.link",
        "thanksreactivity": "Merci d'avance pour votre réactivité",
        "validate": "Une fois le contenu avec son lien en ligne, merci de le valider ici",
        "subjects": {
            "orders": {
                "pending": "NextLevel : votre commande #{orderId} est en attente d'acceptation",
                "pendingBis": "NextLevel : votre commande #{orderId} est toujours en attente d'acceptation",
                "pending2ndReminder": "NextLevel : 2e relance, merci d'indiquer votre accord ou refus pour votre commande partenaire #{orderId}",
                "pending3rdReminder": "NextLevel : Dernière relance pour votre commande #{orderId}, nous attendons de vos nouvelles en urgence",
                "publishReminder": "NextLevel : vous approchez du délai de publication de votre commande #{orderId}",
                "publishLastReminder": "NextLevel : fin du délai de publication aujourd'hui de votre commande #{orderId}",
                "programmedPublishReminder": "NextLevel : Dans 2 jours, rappel, vous avez une publication planifiée à honorer pour votre commande #{orderId}",
                "programmedPublishToday": "NextLevel : C'est aujourd'hui que vous devez publier votre commande partenaire #{orderId}",
                "refus": {
                    "hs": "Votre site est Hors Service : il contient une commande NextLevel en cours de validité (ref #{orderId})",
                    "outboundLinkProblem": "Problème de lien sortant nouvellement apparu sur votre commande #{orderId} en cours.",
                    "numberOfWordsProblem": "Problème concernant le nombre de mots ajoutés sur votre commande #{orderId} en cours",
                    "linkUndetected": "Problème sur votre commande #{orderId} en cours, le lien n’est pas détecté.",
                    "orderUpdated": "Problème d’une modification nouvellement apparue sur votre commande #{orderId} en cours."
                }
            },
            "oubli": "Mot de passe oublié",
            "creditApplication": "Demande de Crédit pour votre accompagnement #{accompagnementId}",
            "newOpportunity": "Nouvelles opportunités NextLevel.link",
            "alert": "Votre site correspond à un besoin client NextLevel - Alerte {numAlert}",
            "register": "Bienvenue chez Nextlevel.link",
            "neworder": "Nouvelle commande NextLevel.link",
            "neworderpartner": "Partenaire : Nouvelle commande NextLevel.link (ref #{orderId})",
            "activation": "Activation de votre site sur NextLevel.link",
            "newparnersite": "Nouveau site partenaire NextLevel.link",
            "newcontent": "Contenu NextLevel.link disponible (commande réf #{order})",
            "contentpublished": "Contenu NextLevel.link publié (commande réf #{order})",
            "whidrawaldemand": "Réception de votre demande de retrait de gains NextLevel.link",
            "gainsdemand": "Demande de retrait de gains NextLevel.link",
            "receptionask": "Réception de votre demande de retrait de gains NextLevel.link",
            "validateask": "Validation de votre demande de retrait de gains NextLevel.link",
            "yourorder": "Votre commande #{orderId} pour le mot-clé : {keyword} a été refusée sur NextLevel.link !",
            "onthekeyword": "pour le mot-clé",
            "refused": "a été refusée sur NextLevel.link",
            "acceptedbypartner": "Le partenaire a accepté la commande #",
            "newdemand": "Nouvelle demande d'accompagnement",
            "modifactiondemand": "Modification demande d'accompagnement",
            "buyexactkeyword": "Achat du mot clé exact d'une précommande",
            "preorderagain": "Poursuite de la précommande pour le mot clé",
            "stoppreoder": "Arrêt de la précommande pour le mot clé",
            "preorderavailable": "Votre précommande est disponible",
            "buycredit": "Achat de crédits via virement",
            "deleteask": "Demande de suppression de compte",
            "addcredit": "Ajout de crédits pour l'un de vos accompagnements"
        },
        "activation-site-partenaire": {
            "validation": "Un de vos sites vient d'être validé sur la plateforme NextLevel.link ",
            "validationtime": "Plusieurs minutes sont nécessaires avant l'affichage du nombre de mots clés présents dans l'outil NextLevel (urls sans liens sortants externes avec des mots clés top 90 dans Google)",
            "list": "Retrouvez la liste de vos sites sur l'écran"
        },
        "alerte": {
            "followup": "Suite à votre demande d'alerte e-mail sur",
            "keyword": "le mot-clé",
            "keywords": "les mots-clés",
            "nbposition": "Nombre de positions",
            "top10": "Top 10",
            "opportunities": "voici les opportunités",
            "link": "Pour régler, supprimer ou limiter la réception de vos alertes, vous pouvez augmenter les critères de sélection, rendez-vous sur",
            "creationtool": "l'outil de création d'alerte"
        },
        "alerte-partenaire": {
            "interest": "Nous vous envoyons ce mail car vous avez manifesté l’intérêt de recevoir une alerte",
            "alertcustomer": "lors d’un besoin de l’un de nos clients sur NextLevel",
            "content": "Un ou plusieurs clients ont un besoin précis et votre site",
            "idealsite": "serait l’endroit idéal pour eux",
            "submitarticle": "Nous vous invitons à regarder, à rédiger et à soumettre l’url de l'article ici",
            "articledonealert": "afin de l’alerter une fois positionné",
            "newkeyword": "Voici donc les nouveaux mots clés à rédiger",
            "dateoffer": "Date de la demande",
            "otherpartner": "Autres partenaires intéressés",
            "description": "Dans la très large majorité des cas, gardez bien à l'esprit que si un client demande par exemple le mot clé \"réparer iphone\", alors vous pouvez bien souvent vous positionner plus vite sur \"réparer iphone tombé dans l'eau\". Le client est alors averti qu'une page dans NextLevel dispose du mot clé non exact",
            "alertssetup": "Pour régler, supprimer ou limiter la réception de vos alertes, rendez-vous sur mes",
            "partneralert": "alertes partenaire"
        },
        "commande-acceptee": {
            "partner": "Le partenaire",
            "partner_02": "le partenaire",
            "partneraccept": "a accepté la commande",
            "redaction": "Rédaction par"
        },
        "commande-refusee": {
            "content": "Vous avez choisi de poser un lien sur le site d'un partenaire de la plateforme Nextlevel le ",
            "detail": "dont voici le détail",
            "explanation": "Le partenaire a refusé le lien pour le motif suivant ",
            "explanation_01": "La ligne éditoriale proposée ne convient pas au partenaire",
            "explanation_02": "Il estime que votre demande et sa page sont concurrentes. Afin de limiter le risque de refus lors de vos prochaines commandes, nous avons bloqué ce site des résultats de recherche de votre projet."
        },
        "commande-terminee": {
            "content": "Votre lien a été posté, vous pouvez le consulter sur votre tableau de bord ",
            "content_01": "Pour vous connecter",
            "content_02": "Passez au niveau supérieur"
        },
        "information-partenaire-supression-precommande": {
            "interest": "Vous aviez manifesté votre intérêt pour la précommande",
            "nopreorder": "Nous devons vous signaler avec regret que le client, après avoir trouvé son besoin sur un autre site NextLevel, ne souhaite pas maintenir sa demande pour de prochaines commandes"
        },
        "notification-contenu-partenaire": {
            "content": "Bonjour, le contenu que nous avons rédigé pour votre page",
            "order": "commande",
            "available": "est maintenant disponible",
            "link": "Le contenu ainsi que le détail de la commande est disponible sur la plateforme à l'adresse suivante",
            "plugin-information-1": "Pour gagner du temps sur vos prochaines commandes : installez le",
            "plugin-information-link": "plugin NextLevel",
            "plugin-information-2": "et vos commandes seront publiées sur votre site automatiquement après acceptation de celles-ci."
        },
        "notification-publication-via-plugin-partenaire": {
            "content": "Bonjour, le contenu que nous avons rédigé pour votre page",
            "nowpublished": "est maintenant publié",
            "ordersummary": "Le résumé de la commande est disponible sur la plateforme à l'adresse suivante",
            "gains": "Vos gains sont désormais disponibles sur votre compte partenaire",
            "engagement": "Nous vous rappelons que vous êtes engagé pour une durée de 24 mois"
        },
        "nouvelle-commande": {
            "newlink": "Un nouveau lien vient d'être acheté sur la plateforme NextLevel.link",
            "user": "Utilisateur",
            "mainkeyword": "Mot-clé principal",
            "secondarykeyword": "Mots-clés secondaires de la page",
            "publishdate": "Date de publication",
            "secondlink": "Second lien",
            "secondanchor": "Seconde ancre",
            "content": "Contenu",
            "brief": "Brief",
            "warning": "Attention : le site est un site partenaire. Le partenaire concerné",
            "mail": "vient d'être prévenu par mail",
            "copywriting": "C'est lui qui rédige le contenu.",
            "copywriting_you": "Une fois le contenu rédigé, merci de lui communiquer"
        },
        "precommande": {
            "infos": "Vous avez effectué une précommande sur le mot clé",
            "results": "un ou plusieurs résultats sont désormais disponibles ici"
        },
        "apidocumentation": {
            "title": "API Documentation"
        },
        "relance": {
            "hi": "Bonjour {firstname}",
            "creationaccount": "Vous venez de créer un compte sur",
            "addcredit": "mais n’avez pas encore passé l’étape de l’ajout de crédit. Laissez-nous vous éclairer pour mieux vous accompagner",
            "showdatas": "Plus de données visibles avec du crédit",
            "withoutcredit": " Sans crédit, vous n’avez pas accès à l’ensemble des données nécessaires à l’achat d’un backlink. Après ajout de 100€ de crédit minimum, vous pourrez en voir davantage : mots-clés positionnés, nombre de positions d'un article dans le top 10 de Google...",
            "paypalnotneeded": "Pas besoin de créer un compte Paypal",
            "paypaldescription": "Si c’est Paypal qui vous rebute, pas de soucis. Vous pouvez ajouter du crédit à l’outil sans avoir de compte, Paypal sert simplement d’intermédiaire pour sécuriser les données de paiement en ligne. Pour créditer votre compte autrement, n’hésitez pas à passer par notre service comptabilité",
            "discoverkeywords": "Découvrez tous vos mots clés en un clic",
            "relevantkeywords": "Pour trouver facilement les mots-clés les plus pertinents disponibles, vous pouvez utiliser la synchronisation de votre Google Search Console avec les articles positionnés de la plateforme. NextLevel vous remontera tous les backlinks potentiels dans votre thématique",
            "efficacy": "Efficace et concret",
            "proofs": "Enfin, vous ressentez encore le besoin de preuves de l’efficacité de l’outil ?",
            "testimonials": "Retrouvez les témoignages",
            "successtestimonials": "de ceux qui ont vu grimper leur position en peu de temps sur le blog",
            "questions": "Vous avez d’autres questions ? N’hésitez pas à nous les faire parvenir, nous sommes ouverts aux suggestions et essayons avant de tout de proposer un outil pratique et fonctionnel. Nous sommes à votre écoute via le chat présent sur le site",
            "dontwait": "N'attendez plus pour",
            "tocredit": "créditer",
            "waitingforyou": "et commencer à ranker, on vous attend",
            "linknotshowingup": "Si le lien ne s’affiche pas, collez cette URL dans votre navigateur "
        },
        "relance-acceptation-partenaire-1": {
            "infos": "Cher partenaire, vous avez reçu il y a 3 jours une commande pour le site"
        },
        "relance-acceptation-partenaire-2": {
            "infos": "Cher partenaire, vous avez reçu il y a 6 jours une commande pour le site"
        },
        "relance-acceptation-partenaire-3": {
            "infos": "Cher partenaire, vous avez reçu il y a 9 jours une commande pour le site",
            "answerneeded": "Vous n'avez à ce jour toujours pas indiqué si vous acceptiez la commande, ou si vous aviez décidé de la refuser. Le délai total de publication étant de 10 jours, nous vous demandons de bien vouloir répondre le plus rapidement possible",
            "declineorder": "Sans réponse de votre part, nous serons malheureusement contraint de refuser cette commande"
        },
        "relance-acceptation-partenaire-info-client": {
            "info": "vous avez une commande sur notre plateforme en attente d'acceptation du partenaire depuis 5 jours. Nous suivons cette commande, et sachez que nous avons d'ores et déjà relancé notre partenaire afin d'obtenir sa décision",
            "orderstatus": "A noter, que depuis votre interface client, vous avez le statut de la commande, selon l'étape à laquelle elle se trouve, de l'acceptation à la validation"
        },
        "relance-publication-partenaire-1": {
            "content": "Cher partenaire, vous avez accepté une commande datant d'il y a 8 jours. Notre délai étant de 8 jours ouvrés, soit environ 10 jours, nous vous recommandons de publier votre texte rapidement.",
            "redaction_you": "C'est vous qui vous chargez de la rédaction",
            "redaction_us": "Nous nous chargeons de sa rédaction"
        },
        "relance-publication-partenaire-2": {
            "content": "Cher partenaire, le délai de publication de votre commande touche à sa fin. Merci de la publier le plus rapidement possible et d'indiquer sur le site \"J'ai publié\"",
            "assist": "En cas de problème, merci de revenir en urgence vers nous afin que nous puissions prévenir le client",
            "assist_contact": "Soit par le chat assitance du site, soit par mail",
            "skype": "Ou encore par skype"
        },
        "relance-publication-partenaire-3": {
            "deadline": "Cher partenaire, vous avez reçu une commande avec une date précise demandée pour la publication. Nous vous rappelons simplement que vous devrez publier cette commande dans 2 jours"
        },
        "relance-publication-partenaire-4": {
            "deadline": "Cher partenaire, vous avez reçu une commande avec une date précise demandée pour la publication. Cette date est aujourd'hui",
            "publishtoday": "Merci de publier et de valider ce jour cette commande"
        }
    },
    "factures": {
        "amounHT": "Montant HT",
        "amountTTC": "Montant TTC",
        "date": "Date Achat",
        "invoice": "Facture",
        "quotation": "Devis",
        "numberInvoice": "Vous avez {n} facture(s)",
        "title": "Factures",
        "noordersyet": "Aucun achat n'a été effectué sur NextLevel.link",
        "notAvailable": "Non disponible",
        "orderType": "Type"
    },
    "favorites": {
        "allsites": "Tous les sites",
        "excludedtheme": "Thématique à exclure",
        "nextlevel": {
            "title": "Les pépites de Nextlevel",
            "nofav": "Aucun favori Nextlevel pour le moment."
        },
        "noadultfilter": "Afficher les résultats Adulte",
        "nofavyet": "Vous n'avez pas encore enregistré de favoris.",
        "none": "Aucune",
        "partners": "Partenaires",
        "min": "Minimum",
        "title": "Favoris",
        "top": "Top",
        "topten": "Nb top 10"
    },
    "partnerAdmin": {
        "actions": {
            "displayCommercialProfil": "Voir le profil commercial",
            "validate": "Valider le partenaire",
            "invalidate": "Invalider le partenaire",
            "modifyProfile": "Modifier le profile",
            "saveProfile": "Sauver les modifications"
        },
        "status": {
            "label": "Statut partenaire",
            "validate": "Validé",
            "invalidate": "Non Validé",
            "undefined": "Non défini"
        },
        "attestation": {
            "label": "Attestations",
            "with": "Avec des attestations",
            "without": "Sans attestation",
            "validatePopup": {
                "title": "Définir une date d'échéance",
                "label": "Saisir une date d'expiration pour l'attestation"
            },
            "urssafPopup": {
                "title": "Validation automatique URSSAF",
                "label": "Saisir le code de sécurité l'attestation"
            },
            "refusePopup": {
                "title": "Refuser l'attestation",
                "label": "Saisir la raison du refus",
                "comment": "Commentaire"
            },
            "refuseReasons": {
                "olderThan6Month": "Attestation de plus de 6 mois",
                "impossibleToValidate": "Impossible à valider URSSAF",
                "cantRead": "Illisible",
                "urssafMandatory": "URSSAF obligatoire",
                "other": "Autres (champs libres)"
            },
            "actions": {
                "validate": "Valider",
                "cancel": "Annuler",
                "delete": "Effacer",
                "refuse": "Refuser"
            },
            "status": {
                "new": "Nouvelle",
                "validate": "Validée",
                "expired": "Expirée",
                "refused": "Refusée"
            }
        },
        "subscriptionDate": "Inscription",
        "user": "Login",
        "withdraw": "Somme retraits"
    },
    "filtres-liens": {
        "filter": "Nous vous offrons la possiblité de supprimer certains sites des résultats de recherche (par exemple si vous avez déjà des backlinks sur ceux-ci)",
        "filterbykeyword": "Filtrer par mot-clé",
        "filterbytheme": "Filtrer par thématique",
        "filterdescription": "Ces filtres peuvent être globaux ou par projet. Indiquez ci-dessous les noms de domaines des sites (un par ligne) que vous ne souhaitez plus voir apparaître",
        "filterglobal": "Filtre global",
        "filteroftheproject": "Filtre du projet ",
        "filterotherlinks": "Filtrer mes autres liens",
        "update": "Vos filtres ont bien été mis à jour !"
    },
    "layout": {
        "addkeyword": "Ajout mots-clés",
        "advice": "Besoin de conseils, contactez-nous ",
        "advisor": "Consultant",
        "advisors": "Consultants",
        "alerts": "Alertes",
        "alertscustommerneeds": "Alertes",
        "availablesites": "Sites dispo / utilisateur",
        "cgv_full": "Conditions Générales de Vente",
        "cgv": "CGU - CGV",
        "cgv_mobile": "CGV clients",
        "cgvpartners": "CGV partenaires",
        "cgvpartners_mobile": "CGV partenaires",
        "clickhereaccount": "Revenir à mon compte",
        "clickhereconseils": "Revenir aux accompagnements",
        "clickhereaccompagnement": "Revenir à mes accompagnements consultant",
        "clientaccount": "Attention, vous êtes connecté avec le compte d'un client",
        "config": "Configuration",
        "configmails": "Configuration mails",
        "contact": "Contact",
        "counseilling": "Accompagnement",
        "custommers": "Clients",
        "customerneeds": "Besoin des clients",
        "dashboard": "Tableau de bord",
        "emailsales": "Email commercial",
        "emailsupport": "Email support",
        "faqcustommers": "FAQ client",
        "faqpartners": "FAQ partenaire",
        "gains": "Gains",
        "getcouseilling": "Me faire accompagner",
        "invoicessummary": "Rapport commandes",
        "keywords": "Mots clés",
        "launch-credit": "Déclenchement Crédit",
        "launch-invoice": "Déclenchement Facture",
        "launch-wait": "Déclenchement Attente",
        "lastsearch": "Dernières recherches",
        "lastglobalsearch": "Dernières recherches globales",
        "markasread": "Marquer comme lu",
        "markallasread": " Tout marquer comme lu",
        "myagency": "Agence",
        "mycounseillors": " Mon agence",
        "nosearchyet": "Vous n'avez effectué aucune recherche",
        "partners": "Support / Partenaires",
        "payments": "Paiements",
        "phonecustommer": "Téléphone Client",
        "phonepartner": "Téléphone Partenaires / Support",
        "preorder": "Précommander",
        "preorders": "Précommandes",
        "profil": "Profil",
        "promocode": "Code Promo",
        "promourl": "Toutes les urls des sites Nextlevel bronzes et argents \"<strong>\" à moins 50%\"</strong>\", profitez-en tout le week-end et jusqu'à lundi 23h59",
        "researchdomain": "Par domaine",
        "researchkeyword": "Par mot-clé",
        "researchkeywordlist": "Par liste de mots-clés",
        "researchtheme": "Par thématique",
        "researchurl": "Par page",
        "selling-websites": "Vente de sites",
        "seeallthesearch": "Voir toutes les recherches",
        "seeallnotifications": "Voir toutes les notifications",
        "seedatas": "Pour voir l'intégralité des données, merci de ",
        "seedatascredits": "créditer votre compte",
        "tracking": "Suivi",
        "transfer": "Virement",
        "billing": "Facturation",
        "urlsummary": "Rapport URLS Proposées",
        "users": "Utilisateurs",
        "user-attestation": "Attestations utilisateurs",
        "partner-admin": "Partenaires",
        "whidraw": "Retrait",
        "validateProfile": "Merci de mettre à jour vos informations personnelles et adresse de facturation avant tout retrait",
        "site-external-links": "Gestion des liens externes",
        "netlinkingplatform": "Plateforme Netlinking",
        "coupon-management": "Gestion des coupons",
        "last-researches": "Dernières recherches",
        "not-found": "La page que vous avez demandé n'existe pas",
        "not-found-title": "Oups ...",
        "unauthorized": "La page n'est pas autorisée",
        "unauthorized-title": "Hum ..."
    },
    "login": {
        "username": "Adresse email",
        "password": "Mot de passe",
        "connexion": "Se connecter",
        "forgotten_password": "Mot de passe oublié ?",
        "notyetregister": "Pas encore inscrit ?",
        "or": "ou",
        "register": "Inscrivez-vous",
        "error": "Erreur lors de la connexion !",
        "userOrPasswordFailed": "Utilisateur ou mot de passe incorrect."
    },
    "partenaire-commandes-detail": {
        "title": "Détails de la commande"
    },
    "mes-accompagnements": {
        "ambition": "Ambition",
        "alreadydone": "Déjà effectué",
        "ask": "Demande d'accompagnement",
        "asksent": "Votre demande d'accompagnement a bien été envoyée !",
        "brief": "Votre brief",
        "budget": "Budget mensuel",
        "budgetglobal": "Budget Global",
        "budgetspend": "Budget Dépensé",
        "budgeturl": "Budget par url par mois",
        "clientbrief": "Brief client",
        "datestart": "Date Début",
        "dateend": "Date fin",
        "details": "Détails accompagnement",
        "duration": "Durée de l'accompagnement",
        "gettheposition": "Récupérer la position",
        "help-no": "Je ne souhaite pas me faire accompagner gratuitement",
        "help-yes": "Je souhaite me faire accompagner gratuitement",
        "invoices": "Régler mes factures d'accompagnement",
        "invoicegeneration": "La facture a bien été générée",
        "invoicegenerationfailed": "La facture n'a pas été générée. Contactez le support.",
        "keywordstoadd": "Ajouter mot-clé / page à travailler",
        "keywordstoworkon": "Mots clés et pages à travailler",
        "keywordfrompage": "Mots clés de la page",
        "lastposition": "Dernière Position",
        "lastposition-alt": "Dernière Pos.",
        "manualposition": "1ère Position manuelle",
        "manualposition-alt": "1ère Pos.",
        "min-budget": "Attention l'accompagnement gratuit ne peut commencer à moins de 500€/mois ou 1500€",
        "noorder": "Aucune commande pour ce mois",
        "opti": "Opti",
        "optihalf": "Semi Opti",
        "positioninit": "Position Initiale",
        "request": "Requêtes",
        "seeorders": "Voir les commandes",
        "sitecategory": "Catégorie du Site",
        "supportdatestart": "Début de l'accompagnement",
        "supportdateend": "Date de fin de l'accompagnement",
        "supportsave": "Enregistrer l'accompagnement",
        "supportlaunch": "Lancer l'accompagnement",
        "time": "Durée (mois)",
        "title": "Accompagnements",
        "todefine": "A définir",
        "toworkon": " À travailler",
        "urltopush": "Url à pousser",
        "url": "URL Achetée",
        "variation": "Variation",
        "variation-alt": "Var.",
        "workonpage": "Page à travailler",
        "waitingcredit": "En Attente de Crédit"
    },
    "mes-credits": {
        "balancebefore": "Balance Avant",
        "balanceafter": "Balance Après",
        "buycredits": "Acheter des crédits",
        "credits": "Crédits",
        "title": "Crédits",
        "myorder": "Ma commande"
    },
    "next-level": {
        "anchorimg": "Ancres images",
        "anchors": "Ancres génériques",
        "cancelsearch": "Annuler ma recherche",
        "confirm": "Êtes-vous sûr ?",
        "exactsearch": "Recherche exacte",
        "externallink": "Lien externe",
        "filtersless": "Moins de filtres",
        "filtersmore": "Plus de filtres",
        "keywordimg": "Mot-clés image",
        "mailsent": "Mail envoyé",
        "newpartners": "De nombreux partenaires sont ajoutés chaque jours sur Nextlevel, mettez en place une alerte pour savoir quand un article se positionne sur",
        "noarticle": "Aucun article présent sur Nextlevel ne se positionne sur ce mot clé",
        "nodiscount": "Pas de résultat en Promo sur cette requête",
        "noworries": "Aucune inquiétude",
        "optimizedkeyword": "Mots-clés optimisés",
        "optimizedanchors": "Ancres optimisées",
        "preorder": "Faire une pré commande pour tenter de positionner un article sur votre mot clé",
        "preorderfree": "Précommander des articles GRATUITEMENT",
        "recommandation": "Nous vous recommandons ",
        "recommandation_02": "soit de rechercher d'autre mots de la thématique, et pas uniquement votre mot clé précis",
        "recommandation_03": "soit de rechercher dans le cadre d'une recherche par mot clé, pas uniquement ici dans la zone promotion, pour y trouver plus de résultats",
        "searchkeyword": "Rechercher mot clé",
        "searchmoresimple": "Essayez une recherche plus simple, par exemple",
        "track": "Nous ne suivons pas ce mot clé actuellement",
        "twopossibility": "Vous avez deux possibilités",
        "typekeyword": "Tapez un mot clef",
        "requestnewtry": "Essayez aussi les requêtes suivantes",
        "wait": "Patientez un instant, nous l'ajoutons à notre base"
    },
    "notifications": {
        "deleteall": "Tout effacer",
        "learnmore": "En savoir plus",
        "nonotifications": "Vous n'avez pas de notifications",
        "title": "Notifications",
        "date": "Date",
        "titre": "Titre",
        "message": "Message",
        "read": "Lu",
        "unread": "Non-Lu",
        "state": "Etat"
    },
    "oubli": {
        "title": "Mot de passe oublié",
        "username": "Adresse email",
        "resetPassword": "Réinitialiser mon mot de passe",
        "resetConfirmationTitle": "Succès",
        "resetConfirmationMessage": "Vous allez recevoir un email vous permettant de modifier votre mot de passe.",
        "resetFailed": "Ce nom d'utilisateur n'existe pas.",
        "backToLogin": "Se connecter"
    },
    "oubli-etape-2": {
        "title": "Changement de mot de passe",
        "passwordChangedTitle": "Succès",
        "passwordChangedMessage": "Votre mot de passe a bien été modifié.",
        "invalidLink": "Ce lien n'est pas valide.",
        "userNotExists": "Cet utilisateur n'existe pas.",
        "newPassword": "Nouveau mot de passe",
        "newPasswordConfirmation": "Confirmer le nouveau mot de passe",
        "changePasswordAction": "Changer mon mot de passe",
        "linkToLogin": "<a href=\"login.php\">vous connecter en cliquant ici.</a>",
        "passwordChangedError": "Il y a eu une erreur lors de la modification du mot de passe. Merci de vérifier les informations saisies."
    },
    "precommande": {
        "reference": {
            "long": "Référence",
            "short": "Ref."
        },
        "add": "Ajouter une précommande",
        "all": "Tous",
        "aboutkeyword": "A propos de votre commande sur le mot clé ",
        "cancelpreorder": "Annuler la précommande",
        "cancelpreorders": "Annuler les {length} précommandes",
        "changeproject": "Déplacer la commande dans le projet",
        "changeprojects": "Déplacer les {length} commandes dans le projet",
        "columns": {
            "locale": "Langue",
            "keyword": "Mot-clés",
            "keywordplaceholder": "Recherche par mot-clé",
            "secondarykeyword": "Mot-clés secondaires",
            "secondarykeywordplaceholder": "Recherche par mot-clé secondaire",
            "brief": "Brief",
            "briefplaceholder": "Recherche par brief",
            "nbArticle": "Nombre d'article souhaité",
            "project": "Projet",
            "createdat": "Créé le",
            "createdatplaceholder": "Recherche par date",
            "expires": "Expire"
        },
        "date": "Date de commande",
        "list": "Liste de mes précommandes d'articles",
        "neworder": "Souhaitez-vous prolonger cette précommande pour réaliser de nouvelles commandes ou votre besoin est-il déjà réalisé ?",
        "neworderkeyword": "Souhaitez-vous prolonger cette précommande pour réaliser de nouvelles commandes, notamment sur le mot clé exact, ou votre besoin est-il déjà réalisé ?",
        "otherordersyes": "Oui , je suis intéressé pour faire d’autres commandes sur ce mot clé et je maintiens ma précommande active",
        "otherordersno": "Non, je ne veux pas maintenir ma précommande. Je referai une précommande du même mot clé ultérieurement si je le souhaite",
        "placeorder": "Vous avez passé commande d’une url positionnée sur le mot clé « ",
        "placedorderalready": " », pour lequel vous aviez fait une précommande",
        "placedurl": "Nous avions positionné une url sur un mot clé non exact se rapportant à votre précommande sur le mot clé «",
        "redactionongoing": "En rédaction",
        "restartorder": "Relancer la commande",
        "restartorders": "Relancer {length} commandes",
        "status": {
            "encours": "En cours",
            "expiree": "Expirée",
            "stopped": "Arrêtée",
            "todo": "A faire",
            "inprogress": "En rédaction",
            "awaiting": "Attente positionnement",
            "done": "Fait",
            "all": "Tous"
        },
        "validate": "Valider",
        "waintingposition": "Attente positionnement"
    },
    "partenaire-commandes": {
        "title": "Commandes",
        "export": "Export CSV",
        "terminate-error": "Terminée avec erreurs",
        "publication_date": "Date de publication",
        "orderlist": {
            "all": "Toutes les commandes",
            "toaccept": "Commandes à accepter",
            "todealwith": "Commandes à traiter",
            "finished": "Commandes terminées",
            "finishederror": "Commandes terminées avec erreurs",
            "denied": "Commandes refusées / annulées "
        },
        "error": {
            "noorder": "Vous n'avez pas réalisé de commande",
            "validate": "Vous n'avez pas de commande à valider",
            "manage": "Vous n'avez pas de commande à traiter.",
            "finished": "Vous n'avez pas de commande terminée.",
            "finish+error": "Vous n'avez pas de commande terminé avec erreur",
            "refused": "Vous n'avez pas refusé de commande"
        },
        "cancel": {
            "title": "Refus de commande",
            "reason": "Motif du refus",
            "concurrent": "Il s'agit d'un concurrent direct",
            "hs": "Commande hors sujet par rapport au contenu de l'article",
            "error": "Erreur de ma part, je ne souhaitais pas mettre en vente cette URL",
            "price": "Le prix ne me convient pas",
            "details": "Merci de détailler le motif de votre refus (10 caractères min.)"
        },
        "gain700": "Vous avez atteint 700 euros de gains sur Nextlevel",
        "minigain": "Gain minimum souhaité pour l'URL*",
        "minigainsite": "Gain minimum souhaité pour l'ensemble de ce site.",
        "gainwarning": "Attention : un gain plancher trop élevé risque de diminuer fortement vos commandes.",
        "plannedorder": "Cette commande est planifiée, vous ne pouvez la publier trop en avance.",
        "refresh": "Une fois vos relances de vérification faîtes, merci de rafraichir la page",
        "extlinks": "Présence de liens externes",
        "seedetails": "Voir le détail",
        "refuseorder": "Refuser la commande",
        "acceptorder": "J'accepte la commande",
        "acceptorders": "J'accepte les commandes",
        "Irefuseorders": "Je refuse les commandes",
        "Irefuseorder": "Je refuse la commande",
        "wantedpublication": "Publication souhaitée",
        "gains": "Gain après mise en ligne",
        "wordsyou": "mots à rédiger par vous",
        "wordnextlevel": "mots seront rédigés par NextLevel",
        "wordsnextlevelongoing": "mots en cours de rédaction par NextLevel",
        "contentredaction": "Contenu en cours de rédaction par NextLevel",
        "contentredactionwaiting": "Le contenu sera rédigé par NextLevel quand la commande sera acceptée",
        "seecontent": "Voir le contenu",
        "see-error": "Voir les erreurs",
        "relancecheck": "Relancer la vérification",
        "redactionNL": "Déléguer la rédaction à Nextlevel (service gratuit)",
        "acceptredactionNL": "Accepter la commande et déléguer la rédaction à Nextlevel (service gratuit)",
        "published": "J'ai publié",
        "pending": "En attente",
        "response-code": "Code de réponse",
        "valid-edit-orders": "Vos commandes ont été modifiées",
        "valid-edit-order": "Votre commande a bien été modifiée",
        "invalid-edit-orders": "Vos commandes n'ont pas pu être modifiées",
        "invalid-edit-order": "Votre commande n'a pas pu être modifiée",
        "verify-date": "Veuillez vérifier les dates de publications souhaitées",
        "confirm-accept": "En continuant vous confirmez accepter les commandes suivantes",
        "confirm-refuse": "En continuant vous confirmez rejeter les commandes suivantes",
        "confirm-publish": "En continuant vous confirmez avoir publié les commandes suivantes",
        "published-orders": "Commandes publiées",
        "external-links": "Liens externes",
        "first-link": "Premier lien / Première ancre",
        "second-link": "Deuxième lien / Deuxième lien",
        "test-word-count": "Test nombre de mots",
        "refresh-only": "Rafraîchir la page",
        "choose-format": "Veuillez choisir le format du fichier d'export",
        "get-data": "Récupérer les données",
        "back": "Retour aux commandes",
        "found-errors": "Des erreurs on été retrouvées sur vos commandes",
        "orderdetail": {
            "title": "Détail de la commande ",
            "nofoundorder": "La commande n'a pas été trouvée.",
            "publishdate": "Date de publication souhaitée par le client : ",
            "publishdatethanks": "Merci de ne pas publier avant cette date.",
            "addurl": "Merci d'ajouter cette commande sur votre site à la page demandée, puis de venir la valider dans votre liste de commandes."
        },
        "sending-date": "Date d'envoi"
    },
    "partenaire-gains": {
        "title": "Gains",
        "cgvknowledge": "Je certifie avoir pris connaissance des CGV. Rappel : les crédits ne pourront pas être retirés et devront être utilisés exclusivement au sein de NextLevel",
        "current-gain": "Gains en cours : ",
        "event": "Évènement",
        "amount": "Montant",
        "nogainsyet": "Vous n'avez pas encore de gains.",
        "picktheamount": "Choisissez le montant : transférez vos gains en crédits et gagnez automatiquement {bonus}% de crédits offerts.",
        "transform": "Transformer en crédits",
        "amounttransform": "Montant à transformer",
        "gift": "Crédits Offerts",
        "withdrawfundsdone": "Vous avez déjà un retrait en cours ce mois-ci, merci de réaliser votre nouvelle demande le mois prochain",
        "withdrawfunds": "Retirer mes gains ",
        "amounttowithdraw": "Montant à retirer",
        "errororder": "Vous avez une ou plusieurs commande(s) en erreur(s).",
        "correct": " Merci de rectifier ",
        "yourerrors": "vos erreurs ici",
        "errortransfer": "afin de pouvoir retirer ou transférer vos gains",
        "limit": "Rappel : les retraits sont limités à {maxCeilingWithdrawal} euros. Pour retirer vos gains, une facture devra être éditée.",
        "minWithdrawalWarning": "Vos gains sont inférieurs au plancher de retrait de {minWithdrawal} euros.",
        "attestation": "Merci d'ajouter une attestation sur votre page profil.",
        "preferedinvoicing": "Préférence de facturation",
        "generate": "Je génère une facture en ligne (entreprise en France)",
        "mail": "J'envoie ma facture par email",
        "invoicenumber": "Numéro de facture souhaité",
        "invoicemail": "Si vous choisissez d’éditer vous-même votre facture, les coordonnées et informations de facturation vous seront envoyées par mail",
        "exact": "Je certifie l'exactitude des informations transmises et",
        "cgv": "avoir pris connaissance des CGV.",
        "honor": "Je m'engage à ne pas avoir fait d’autre demande de retrait ce mois (après vérification de vos commandes en cours par notre équipe, le règlement sera effectué à J+30).",
        "honorgain": "Je certifie sur l'honneur être informé que les sommes versées supérieures à 600 euros par an doivent être portés sur la déclaration de revenus.",
        "amountmin": "Le montant doit être supérieur à ",
        "maxamount": "Le montant est supérieur à vos gains ou limite autorisée"
    },
    "partenaire-site": {
        "order-auto": "Commande auto.",
        "preorder-auto": "Précommandes auto.",
        "order-preorder-auto": "Commandes auto. / Précommandes auto. (Plugin obligatoire)",
        "manage-auto": "Gestion",
        "after-sale": "après vente",
        "accept-auto": "Commandes automatique",
        "accept-auto-preorder": "Précommandes automatique",
        "accept-auto-info": "Les commandes correspondant à vos critères seront automatiquement acceptées, vous n'aurez plus à le faire manuellement.",
        "accept-auto-info-preorder": "Publication de précommandes sur votre site par rapport à un besoin de Nextlevel.",
        "accept-auto-orders": "Je souhaite, pour les sites sélectionnés, que les commandes soient acceptées automatiquement",
        "accept-auto-preorders": "Je souhaite, pour les sites sélectionnés, que les précommandes soient acceptées automatiquement",
        "addcontent": "Si l'ajout d'un contenu trop important sur vos articles vous dérange, vous pouvez le limiter ici",
        "addlink": "Vous devez ajouter chaque lien commandé dans un délai de 10 jours",
        "addawebsite": "Ajouter un site",
        "download_wp_plugin": "Télécharger le plugin Wordpress",
        "avancedmodedescription": "Dans ce mode, vous pouvez affiner la liste des URLs mis en vente via l'utilisation de sitemaps, et / ou d'une whitelist, et / ou d'une blacklist",
        "advancedoptions": "Options avancées",
        "all-no-url": "Toutes sauf URL",
        "allowplanning": "Autoriser au client la planification de la publication du lien",
        "alreadybought": "Vous avez déjà acheté un lien pour ce domaine sur ce site.",
        "alltheanchors": "Toutes les ancres (option recommandée)",
        "all-site": "Tout le site",
        "anchors": "Ancres acceptées",
        "avancedmode": "Mode avancé : je ne valide qu'une partie du site",
        "attenteamelioration": "En attente d'amélioration",
        "back": "Retour aux sites",
        "blacklist-textfile": "Blacklist via fichier texte",
        "blacklisturl": "URLs sont définies en blacklist. Cliquez ici pour les supprimer",
        "blacklist-groups-info": "Vous pouvez déterminer les thématiques dont vous ne souhaitez pas avoir de liens",
        "blacklist-groups-label": "Définir les thématiques refusées",
        "blacklist-groups-add": "Ajouter une thématique",
        "cgv": "les CGV*",
        "choice": "Choix",
        "cmstype": "Type de CMS",
        "confirm": "Je confirme vouloir placer une autre fois un lien vers ce domaine sur ce site.",
        "confirmsupress": "Êtes-vous sûr de vouloir supprimer votre site ",
        "deletesite": "Suppression de mon site",
        "deletesites": "Suppression de vos sites",
        "deactivateddNextLevel": "Site désactivé par NextLevel. Contacter le support pour en savoir plus",
        "deactivatedtemp": "Désactivé temporairement par vous-même",
        "desactivation": {
            "titre": "{ndd} a été désactivé",
            "titre-temp": "{ndd} a été désactivé temporairement",
            "message": "Le site {ndd} de {usernameNL} a été désactivé sur notre plateforme Nextlevel.",
            "message-temp": "Le site {ndd} de {usernameNL} a été désactivé sur notre plateforme Nextlevel. Date de réactivation : {dateEnd}"
        },
        "amelioration-site": {
            "modifs": {
                "rd": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Votre site ne remplit pas encore tous nos critères de qualité. Nous gardons votre site en attente, il sera accepté dès qu'il présentera plus de 20 domaines référents.",
                "content": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Votre site ne possède pas assez de mots-clés. N'hésitez pas à créer de nouveaux contenus afin que nous puissions valider votre site. Nous revérifierons cet aspect dans les semaines à venir.",
                "links": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Votre site dispose de trop de liens sortants au sein des contenus ce qui lui empêche d'avoir des pages en vente sur Nextlevel. Nous revérifierons cet aspect dans les semaines à venir.",
                "design": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel. Cependant nous mettons votre site en demande d’améliorations pour le design. Merci de mettre un design plus dynamique et imagé. Nous vous encourageons aussi à intégrer un favicon. Nous revérifierons votre site dans les prochains jours.",
                "onepage": "Bonjour, nous apprécions votre demande de partenariat sur NextLevel.  Nous mettons votre site en attente car c'est un one page. Merci d'ajouter des catégories et nous revérifierons cet aspect dans les semaines à venir."
            }
        },
        "deactivationfrom": "Désactivation prévue du ",
        "deactivateduntil": "Désactivé jusqu'au ",
        "desactivationwebsite": "Désactivation de mon site",
        "desactivationwebsites": "Désactivation de mes sites",
        "desactivationtemporary": "Désactivation temporaire",
        "desactivationwithoutdate": "Désactivation sans date",
        "disapointed": "Je suis déçu par le prix des liens",
        "dontownthesite": "Le site ne m'appartient plus",
        "dontapprouve": "Je n'approuve pas le principe de vente sur des URL existantes",
        "enddate": "Date de reprise",
        "engagement": "Vous vous engagez à maintenir les liens 24 mois",
        "engagementmonths": "Je reste engagé sur 24 mois comme indiqué dans",
        "externallinks": "Seules les pages sans liens externes sortants sont éligibles",
        "generics": "Génériques (cliquez ici, en savoir plus, etc) uniquement",
        "get_generic_anchor": "Obtenir une ancre générique",
        "get_random_anchor": "Obtenir une ancre aléatoire parmis les mots-clés",
        "humanvalidation": "Chaque site est validé manuellement après vérification par nos équipes",
        "site-owner": "Rappel: vous certifiez être le propriétaire de ce site",
        "keywords": "Mots-clés",
        "urls": "URLs",
        "no-keywords": "Aucun mot clé lié à ce domaine",
        "keywords-choice": "Mots-clés compris dans une phrase ou suite de mots uniquement",
        "mainurl": "URL principale, avec http(s)://",
        "maxcontent": "Contenu rédigé maximum accepté par article",
        "MFAconcurrent": "Refus MFA concurrent",
        "minigain": "Gain plancher (nous recommandons de laisser vide au lancement)",
        "minigainexplanation": "Le gain plancher est le gain en-dessous duquel l'URL ne sera pas mise en vente. Indiquez ici le gain minimum pour vous (il ne s'agit pas du prix mais de votre gain).",
        "motif": "Veuillez indiquer une raison",
        "nositeactivated": "Vous n'avez pas de site activé",
        "nositedesactivated": "Vous n'avez pas de site désactivé",
        "nowebsitesawaiting": "Vous n'avez pas de site en attente de validation",
        "nositeyet": "Vous n'avez pas encore de sites",
        "norefused": "Vous n'avez pas de site refusé",
        "nodeletedsite": "Vous n'avez pas de site supprimé",
        "now": "Actuellement",
        "no-recommandation": "Non (option recommandée)",
        "othercms": "Autres CMS",
        "others": "Autres, précisez",
        "orders": {
            "title": "Commande par domaine",
            "no-orders": "Aucune commande lié à ce domaine"
        },
        "partner": "Partenaire",
        "reactivationwebsites": "Reactivation de mes sites",
        "reactivationwebsite": "Reactivation de mon site",
        "reactivationwebsite-text": "Vous confirmer vouloir réactiver le site",
        "reactivationwebsites-text": "Vous confirmer vouloir réactiver tous les sites séléctionnés",
        "redaction": "Rédaction",
        "redactionmyself": "Je rédige moi-même le texte supplémentaire",
        "redactionnextlevel": "Je laisse la rédaction à l’équipe NextLevel",
        "wordpress_plugin": "Plugin Wordpress",
        "wordpress_plugin_settings": "Configuration plugin Wordpress",
        "wordpress_plugin_tooltip": "Version du plugin | Version de Wordpress",
        "secondarylink": "Lien secondaire autorisé",
        "secondarylink-info": "Le client pourra s'il le souhaite demander un deuxieme lien augmentant le prix du lien et donc la rémunération du partenaire",
        "seekeywords": "Voir les mots-clés",
        "selecttxt": "Sélectionner un fichier .txt avec les URLs concernées",
        "simplemode": "Mode simple : je valide tout le site",
        "soldlinks": "pour les liens vendus",
        "startdate": "Date de début",
        "supress": {
            "titre": "{ndd} a été supprimé",
            "message": "Le site {ndd} de {usernameNL} a été supprimé sur notre plateforme Nextlevel. Motif : {noteCustomer}"
        },
        "title": "Sites",
        "to": "au",
        "toomuchsales": "J'ai déjà trop vendu sur ce site",
        "update": "(Mise à jour en cours)",
        "url": "URL concernées",
        "url-choice": "URL (monsite.fr, https://www.monsite.fr) uniquement",
        "urlforsale": "URLs mises en vente",
        "urlsorgeneric": "URL ou génériques uniquement",
        "urlsGenericKeywords": "URL, génériques ou mot clé compris dans une phrase ou suite de mots",
        "valid-save-site": "Votre site a été ajouté. Il est en attente de validation",
        "valid-edit-site": "Votre site a été modifié",
        "valid-edit-sites": "Vos sites ont été modifiés",
        "valid-delete-site": "Vos sites ont bien été supprimés",
        "valid-desactive-site": "Vos sites ont bien été désactivés",
        "valid-reactive-site": "Vos sites ont bien été réactivés",
        "valid-save-wp": "Plugin Wordpress mis à jour",
        "whitelist": "Whitelist via sitemaps XML : entrez les URLS, séparées par une virgule si nécessaire",
        "whitelist-textfile": "Whitelist via fichier texte",
        "whitelisturl": "URLs sont définies en whitelist. Cliquez ici pour les supprimer",
        "wordsrecommandation": "mots (option recommandée)",
        "yes-recommandation": "Oui (option recommandée)"
    },
    "partenaire-mot-cles": {
        "backtosites": "Retour aux sites",
        "blacklist": "Blacklister",
        "blacklistdescription": "En blacklistant une URL, ses mots clés associés seront retirés de la plateforme et ne pourront plus être achetés",
        "blacklistdescription_02": "Vous pourrez remettre en vente une URL ultérieurement en allant dans la section \"URLs mises en vente\" de votre écran Partenaires > Sites.",
        "blacklistURL": "Blacklister l'URL",
        "keyword": "Mot-clé",
        "position": "Position",
        "volume": "Volume",
        "error": {
            "class": "Page invendable",
            "externalLinks": "Liens externes",
            "notScrapped": "Non scrap",
            "price": "Prix plancher",
            "scrap": "Erreur scrap"
        },
        "gainonurl": "Gain pour un lien sur cette URL",
        "gain": "Gain",
        "global-site": "Global - site",
        "global-min-gain-define": "Réinitialisation des gains plancher (Global - site)",
        "global-reset-desc": "Attention, tous vos gains plancher seront supprimés.",
        "isScrapped": "Scrappé",
        "potentialGain": "Gain total potentiel",
        "infos": "Le prix de vente est à titre indicatif et varie en fonction des performances de chaque URL et de ses mots-clés.",
        "label": {
            "all": "Tous",
            "saleable": "Vendables",
            "unsaleable": "Invendables"
        },
        "mainkeyword": "Mot-clé principal",
        "minigain": "Gain plancher",
        "minigainAllURL": "Si vous souhaitez définir un gain plancher global pour toutes les URLs existantes et futures, rendez-vous sur",
        "minigainAllURL_02": "l'écran de gestion de vos sites",
        "minigainAllURL_03": "cliquez sur \"Actions > Modifier\" et ajustez le prix dans les options avancées",
        "minigainnotreached": "Actuellement le gain de l'url défini par notre algorithme n'atteint pas le gain plancher que vous avez fixé.",
        "minigaindefine": "Définir un gain plancher",
        "nokeyword": "Aucun mot-clé n'a été trouvé",
        "reinit": "Reinitialiser",
        "reinitminigain": "Reinitilisation des Gains Plancher",
        "reinitminigaindescription": "Merci de confirmer. Si vous réinitialisez cette fonction, aucun « Gain Plancher » ne persistera pour ces URL sélectionnées",
        "reinitminigaindescription_02": "Ainsi, toutes ces URL sélectionnées seront proposées à la vente, quel que soit le prix défini par notre algorithme. Nous vous demandons d'accepter le maximum de commandes si vous n'utilisez pas la fonction « Gain Plancher »",
        "reinitminigainurl": "Réinitialisation des gains plancher (URL)",
        "reinitminigainsite": "Réinitialisation des gains plancher (Global - site)",
        "rescrap": "Relancer la vérification de l'url",
        "saleablePage": "Page vendable",
        "totalgains": "Gain total de l'ensemble de vos urls pour le site",
        "urlavailable": "Urls disponible à l'achat",
        "urlnotavailabe": "Urls non disponible à l'achat",
        "visibility": "Visibilité dans la recherche",
        "warning": "Attention, tous vos gains plancher seront supprimés",
        "alert-reinit-min-gain": "Gains plancher réinitialisés avec succès",
        "alert-reinit-min-gain-global": "Gain plancher global réinitialisé avec succès",
        "alert-blacklist-urls": "URLS blacklistées avec succès",
        "alert-min-gain": "Nouveau gain plancher enregistrée",
        "no-more-keywords": "Il n'y a pas d'autres mots-clés positionné sur cette URL"
    },
    "partenaire-precommandes": {
        "article-number": "Besoin(s) en article(s)",
        "date": "Date de la demande",
        "export": "Exporter",
        "googleposition": "Dès qu’il obtient une position sur Google, relevée par SEMrush, le client est avisé.",
        "group": "Groupe",
        "intro": "Chaque client NextLevel.link peut passer une précommande et indiquer le mot clé sur lequel il voudrait un article positionné. Lorsque que cela arrive, il est alerté par e-mail, libre à lui ensuite de passer à l’achat du lien, ce qu'il fait dans 90% des cas.",
        "interest": "Mots-clés qui m'intéressent",
        "interest-considered": "Intêret pris en compte",
        "interestedredaction": "Je suis intéressé par la rédaction d'un article à ce sujet",
        "intropartner": "Vous, partenaire, nous vous donnons la possibilité d’en profiter.",
        "nointerest": "Mots-clés pour lesquels je n'ai pas encore manifesté d'intêret",
        "nopreorder": "Aucune précommande n'est disponible.",
        "notinterestedredaction": "Je ne suis plus intéressé par la rédaction d'un article à ce sujet",
        "otherpartners": "Autres partenaires intéressés",
        "price": "Le prix est défini par notre algorithme comme pour n’importe quelle autre commande.",
        "selectkeyword": "Sélectionnez le mot clé qui vous intéresse",
        "redactionwebsite": "Rédigez un article sur votre site",
        "redactors": "Autres rédacteurs intéressés",
        "show-proposals": "Voir mes propositions",
        "suggest": "Proposer une URL",
        "suggestother": "Proposer une autre URL",
        "title": "Rédigez des articles sur les mots clés attendus par nos clients ! ",
        "url": "URL proposée"
    },
    "profil": {
        "navbar": "Sous-menu :",
        "account": "Mon compte",
        "tab": {
            "profil": "Profil",
            "address": "Adresse de facturation",
            "order": "Commandes",
            "sponsorship": "Parrainage",
            "external-api": "API externes",
            "delete-account": "Supprimer mon compte",
            "personnal-data": "Informations personnelles"
        },
        "profil": {
            "modify-password": "Modifier mon mot de passe"
        },
        "delete": {
            "delete-account": "Supprimer mon compte",
            "confirm": "Je confirme la suppression de mon compte",
            "submenu": "Gestion de mes données personnelles"
        },
        "address": {
            "attestation": "Document à fournir",
            "attestation-detail": "(Attestation de vigilance URSAFF ou Extrait de KBIS ou certificat d'inscription Insee)",
            "submenu": "Mes informations professionnelles"
        },
        "orders": {
            "add-receiver": "Ajouter d'autres destinataires des commandes (email)",
            "send-me-a-copy": "Je souhaite recevoir également les emails de commandes",
            "orders": "Commandes",
            "submenu": "Destinataires des commandes"
        },
        "sponsorship": {
            "intro": "Encaissez 5 % du montant total de toutes les commandes de vos filleuls, à vie.",
            "url": "Votre URL de parrainage",
            "compensation": "Rémunération Parrainage",
            "credit": "Crédits",
            "earn": "Gain",
            "unused": "Personne ne s'est inscrit via votre lien pour le moment.",
            "sponsee": "Filleul",
            "depot": "Dépôt",
            "gains": "Gain",
            "gains-totaux": "Gains totaux",
            "sponsee-total": "Filleuls inscrits"
        },
        "external-api": {
            "semrush": "Clé SEMRush"
        },
        "support": {
            "global": "Global",
            "pages": "Pages",
            "dont-forget-to-add-pages": "N'oubliez pas d'ajouter les pages à travailler dans l'onglet \"Pages\".",
            "discuss-with-us-first": "Si vous souhaitez en discuter auparavant avec nous, laissez l'onglet vide.",
            "first-page-to-work-on": "Page 1 à travailler",
            "keywords": "Mots clés de la page 1",
            "anchors": "Ancres de la page 1 (si vous souhaitez que NextLevel gère les ancres, laissez vide)",
            "add-page": "Ajouter une page à travailler",
            "send": "Envoyer ma demande d'accompagnement",
            "modify": "Modification accompagnement"
        },
        "validation": {
            "front": {
                "siret": "Merci de vérifier que votre SIRET soit composé de 14 chiffres sans espace.",
                "tva_number": "Merci de renseigner votre numéro sans espace.",
                "account-confirm-delete": "Merci de confirmer que vous souhaitez supprimer votre compte."
            },
            "back": {
                "email-already-in-use": "Désolé, cette adresse email est déjà utilisée !",
                "email-invalid": "Cette adresse email est invalide.",
                "password-too-short": "Veuillez fournir au moins {limit} caractères pour votre mot de passe.",
                "password-mismatch": "Les mots de passe ne sont pas identiques.",
                "profil-updated": "Votre profil a bien été mis à jour !",
                "order-updated": "Les informations génériques de commande ont bien été mises à jour !",
                "key-updated": "Votre clé a bien été mise à jour !",
                "support-contacted": "Votre demande d'accompagnement a bien été envoyée !"
            }
        },
        "new-password": "Nouveau mot de passe (laisser vide pour conserver votre mot de passe)",
        "confirm-new-password": "Confirmation du nouveau mot de passe",
        "delete-account-confirmation": "Supprimer mon compte",
        "support-request": "Demande d'accompagnement",
        "interface-language": "Langue de l'interface",
        "api-documentation": "Aller à la documentation d'API",
        "api-limit": "Limitations",
        "api-request-time": "Requêtes par minutes maximums",
        "api-auth-login": "Obtenir un token API",
        "api-partner-order": "Récupérer sa liste de commandes",
        "api-partner-needs": "Récupérer la liste des besoins des clients",
        "api-partner-sites": "Récupérer la liste de vos sites",
        "api-partner-preorders": "Récupérer la liste de vos précommandes",
        "api-partner-groups": "Récupérer la liste des groupes",
        "api-partner-lang": "Langue",
        "api-partner-default-lang": "Langue par défaut de votre profil",
        "api-key": "Clé",
        "api-value": "Valeur",
        "api-exemple": "Exemple",
        "api-getted-token": "Votre token d'API récupéré lors du login",
        "api-nextlevel-token": "Votre clé api fournie par NextLevel",
        "api-number-getted": "Le nombre de résultats par page - Défaut : 20",
        "page-number": "Le numéro de la page à afficher - Défaut : 1"
    },
    "projets": {
        "-selector": {
            "current": "Vous travaillez actuellement ce projet",
            "recommandation": "Nous recommandons fortement de créer un projet par site travaillé"
        },
        "actions": {
            "delete": "Supprimer la sélection",
            "deactivate": "Désactiver",
            "deactivating": "Désactivation...",
            "edit": "Éditer le projet",
            "delete_successfull": "Le projet a bien été supprimé | Les projets ont bien été supprimés"
        },
        "columns": {
            "defaultProject": "Projet par défaut",
            "setDefault": "Définir par défaut",
            "name": "Nom",
            "website": "Site web",
            "filteredLinks": "Liens filtrés",
            "status": "Statut",
            "statusActive": "Actif",
            "statusInactive": "Inactif",
            "budget": "Budget",
            "emailRecipients": "Destinataires email",
            "actions": "Actions"
        },
        "all": "Tous",
        "brieflabel": "Brief par défaut du projet",
        "briefdescription": "Insérez le brief par défaut pour les futures commandes du projet.",
        "numberProject": "Vous avez {n} projet(s)",
        "add": "Ajouter un projet",
        "backToProjects": "Revenir à la liste des projets",
        "budget": "Budget mensuel indicatif",
        "budgetmonthly": "Budget mensuel (facultatif)",
        "concerned": "Projet concerné :",
        "create": "Créer un nouveau projet",
        "createproject": "Créer",
        "enterprojectname": "Merci de renseigner le nom du projet !",
        "entervalidmail": "Merci de renseigner des emails valides",
        "filteredLinks": "Filtrer mes autres liens",
        "filteredLinksDesc": "Nous vous offrons la possiblité de supprimer certains sites des résultats de recherche (par exemple si vous avez déjà des backlinks sur ceux-ci).",
        "integer": "Merci de renseigner un nombre entier.",
        "language": "Langage",
        "mailrecipient": "Destinataires des mails",
        "mailrecipients": "Destinataires emails (séparés par une virgule)",
        "mooveto": "Déplacer vers ce projet",
        "moovetoproject": "Déplacer vers un projet",
        "modify": "Modifier un projet",
        "name": "Nom du projet",
        "noprojectsyet": "Vous n'avez pas encore de projets",
        "notsorted": "Non Classé",
        "project": "Projet",
        "projects": "Projets",
        "site-anchors-type": "Type d'ancres acceptées",
        "site-groups-blacklisted": "Thématiques refusées",
        "spendings": "Dépense mois en cours",
        "supress": "Êtes-vous sûr de vouloir supprimer ce projet ?",
        "title": "Projets",
        "update": "Modifier le projet",
        "website": "Site internet",
        "website-info": "Insérer le root domain (monsite.fr) afin de ne plus voir dans la recherche les mots-clés des sites où vous avez déjà acheté un lien"
    },
    "register": {
        "society": "Société",
        "firstname": "Prénom",
        "lastname": "Nom",
        "phone": "Téléphone",
        "address": "Adresse",
        "postalCode": "Code postal",
        "city": "Ville",
        "country": "Pays",
        "tva": "N° de TVA",
        "password": "Mot de passe",
        "promo": "Code promo (facultatif)",
        "skypemessage": "Si vous n'avez pas déjà renseigné votre téléphone, merci de renseigner au moins votre Skype pour le traitement de vos futures commandes.",
        "cgv": "CGV",
        "cgvmessage": "En validant ces CGV, je renonce expressément à mon droit de rétractation",
        "cgvpartner": "CGV partenaires",
        "register": "S'inscrire",
        "partner": "Je veux devenir partenaire",
        "alreadyregister": "Déjà inscrit ?",
        "gains": "Vos gains Partenaire peuvent être transférés en crédits ou être retirés.",
        "gainsWarning": "ATTENTION : Vous devrez renseigner les coordonnées d'une société pour pouvoir retirer vos gains.",
        "alertSMS": "J'accepte de recevoir des SMS en lien avec les commandes de mes sites",
        "login": "Se connecter",
        "title": "Inscription",
        "error": {
            "lenght": "Minimum 6 caractères",
            "number": "Minimum un chiffre",
            "uppercase": "Minimum une majuscule",
            "lowercase": "Minimum une minuscule",
            "symbol": "Minimum un caractère spécial",
            "mismatch": "Les mots de passe ne correspondent pas",
            "mandatory": "Ce champ est obligatoire",
            "cgv": "Vous devez accepter les CGV pour continuer",
            "society": "Vous devez fournir un nom de société si vous souhaitez devenir partenaire",
            "userAlreadyExists": "L'utilisateur existe déjà.",
            "incorrect": "Incorrect",
            "fillAllFields": "Renseigner tous les champs.",
            "phoneFormat": "Format invalide"
        },
        "email": "Email",
        "passwordConfirmation": "Confirmer votre mot de passe",
        "accept": "J'accepte les "
    },
    "suivi": {
        "articles": "Suivi des articles",
        "artileswaiting": "Articles en attente",
        "availablewhenpublished": "Sera disponible une fois publié",
        "dateorder": "Date commande",
        "datepost": "Date publication",
        "editionline": "La ligne éditoriale proposée ne convient pas au partenaire",
        "errorpage": "Il s'agit d'une page que le partenaire a involontairement ajoutée sur la plateforme",
        "invalid-date": "Dates invalides",
        "numberofkeywords": "Nombre de mots clés positionnés",
        "otherkeywords": "Autres mots-clés",
        "otherkeywordspositionned": "Autres Mots Clés positionnés de l'URL",
        "keywordspositionned": "Autres Mots Clés positionnés de l'URL",
        "publishedarticles": "Articles publiés",
        "publishedon": "Article publié sur",
        "seedatas": "Revoir les données",
        "seeLess": "Voir moins...",
        "seemore": "Voir plus... ",
        "seemorekeywords": "Voir plus de mots clés",
        "suppword": "Mots suppl.",
        "url": "Informations URL",
        "urldate": "Données de l'url à la date de la commande",
        "wantedpublication": "Publication souhaitée",
        "move-orders": "Êtes-vous sûr de vouloir déplacer les commandes",
        "in-project": "vers le projet",
        "cannot-found-history": "Impossible de retrouver l'historique complet",
        "error": "Impossible de récupérer les données"
    },
    "searchform": {
        "agency": "MODE AGENCE",
        "agent": "Je représente une agence",
        "assignbudget": "Attribuez le budget à vos collaborateurs",
        "budget": "Budget sur un minimum de 3 mois",
        "clickhere": "CLIQUEZ ICI",
        "rank-domain-max": "RD max.",
        "rank-domain-min": "RD min.",
        "impressions": "Impressions",
        "impressions-min": "Impressions min.",
        "impressions-max": "Impressions max.",
        "clicks": "Cliques",
        "clicks-min": "Cliques min.",
        "clicks-max": "Cliques max.",
        "enterDomain": "Saisissez le root domaine (site.com)",
        "exportselection": "Exporter ma sélection",
        "searchby": "Recherche",
        "searchByTheme": {
            "title": "Recherche par thématique",
        },
        "searchByKeyword": {
            "title": "Recherche par mot clé",
        },
        "searchByDomain": {
            "title": "Recherche par domaine",
        },
        "searchByUrl": {
            "title": "Recherche par page",
        },
        "searchbygsc": "Recherche par Google Search Console",
        "searchbykeywordlist": "Recherche par liste de mot clés",
        "keywordsbydomain": "Mots clés par Domaine",
        "keywordnumber": "Nombre de mots-clés",
        "keywordbyurl": "Mots clés par URL",
        "promourl": "Voir uniquement les URL en Promo",
        "enterValidUrl": "Saisissez une url valide (http(s)://site.com/ma-page)",
        "position": "Position",
        "positionmin": "Position minimum",
        "positionmax": "Position maximum",
        "volume": "Volume",
        "volumemin": "Volume minimum",
        "volumemax": "Volume maximum",
        "withkeyword": "Contenant le mot clé",
        "enter-keyword": "Aucun résultat, saisissez un mot clé",
        "noResultsEnterUrl": "Aucun résultat, saisissez un url",
        "noResultsEnterDomain": "Aucun résultat, saisissez un domaine",
        "select-site": "Aucun résultat, sélectionnez un site",
        "enterurl": "Saisissez votre url",
        "urlnumber": "Nombre d'URLs",
        "urlordomain": "URL exacte ou domaine d'un de vos sites",
        "visibility": "Je veux développer ma visibilité",
        "mentorship": "ACCOMPAGNEMENT",
        "opportunity": "Analyse d'opportunités",
        "analyse": "Analyse OnSite des pages à développer",
        "popularity": "Développement de la popularité",
        "seo": "SEO COMPLET",
        "offsiteseo": "SEO OFF SITE",
        "help": "pour être accompagné",
        "netlinking": "Je veux vous confier mon netlinking",
        "orders": "Nous réalisons les commandes",
        "tracking": "Vous avez accès au suivi ",
        "gestion": "GESTION D'UN COMPTE EN",
        "ui": "Profitez d’une interface adaptée",
        "partner": "Devenez Partenaire de Confiance ",
        "companionship": "ACCOMPAGNEMENT",
        "noArticlesUrl": "Aucun article présent sur Nextlevel ne se positionne sur des mots clés de votre URL",
        "noarticles": "Aucun article présent sur Nextlevel ne se positionne sur des mots clés de votre domaine.",
        "adresssiteurl": "Entrez l'URL de votre choix (de votre site), NextLevel.link ressort ses mot-clés, et vous indique à chaque fois si nous avons des articles disponibles sur ces mots-clés positionnés.",
        "adresssite": "Entrez l'adresse de votre site, NextLevel.link ressort vos mot-clés, et vous indique à chaque fois si nous avons des articles disponibles sur ces mots-clés positionnés.",
        "alreadypositionned": "Entrez un mot-clé, nous recherchons des articles déjà positionnés parmi nos résultats disponibles sur NextLevel.link",
        "typekeyword": "Tapez un mot clé - Recherche avancée possible avec les opérateurs, par exemple : \",\" recherche multiple possible en séparant les termes par une virgule",
        "noRecordedFavoriteYet": "Vous n'avez pas encore enregistré de favoris.",
    },
    "semrush": {
        "enterkey": "Merci de renseigner votre clé SEMRush",
        "beforeacess": "avant d'utiliser cette fonctionnalité",
        "error": "Une erreur est survenue. Votre clé API",
        "iscorrect": "est-elle correcte / avez-vous suffisament de crédits"
    },
    "tableau-keywords": {
        "addlink": "Ajout d'un lien secondaire",
        "addnote": "Ajouter une note",
        "addwords": "Ajout de mots au texte existant",
        "anchor": "Ancre du lien",
        "blacklist": "Blackliste Url",
        "blacklistdescription": "Cette url n'apparaîtra plus dans les résultats de recherche pour tous les utilisateurs, êtes-vous sûr ?",
        "brief": "Brief",
        "buy": "Acheter (prix total: {price}€)",
        "categorysite": "Catégorie Site",
        "clicks": "Clicks",
        "contact": "Contacter le support pour voir la data",
        "credit": "Créditer mon compte pour voir la data",
        "credittoorder": "Créditer mon compte pour commander",
        "date": "Date",
        "discount": "Promo",
        "general": "Généraliste",
        "grades": "Or : site premium, Argent : site medium, Bronze : site basique",
        "impressions": "Impressions",
        "indiceURL": "Indice de puissance de l'URL, 1 étant le plus faible et 100 le plus élevé",
        "insteadof": " au lieu de",
        "keywordavailable": "Mot-clé disponible sur lequel acheter une position",
        "keywordpositionnednumber": "Nombre de mots-clés positionnés sur l'URL",
        "keywordtop10": "Nombre de mots-clés positionnant l'URL dans le top 10",
        "modifynote": "Modifier la note",
        "nextStep": "Suivant (prix total: {price}€)",
        "numberkeyword": "NB de mots clés",
        "numberkeywordpositionned": "Mots clés positionnés",
        "orderlink": "Commander un lien",
        "partnersite": "Site partenaire",
        "position": "Position",
        "pricewithoutVAT": "Prix HT.",
        "promo": "Promo",
        "publicationplanned": "Publication planifiée",
        "publicationsoon": "Publication dès que possible",
        "quantity": "Volume de recherche mensuel moyen du mot-clé dans Google",
        "rank": "Rank",
        "secondarylinkanchor": "Ancre du lien secondaire",
        "secondarylinkurl": "L'url du lien secondaire à placer",
        "serpPosition": "Position du mot-clé dans la SERP de Google (Source : SEObserver). Ex : si top 50, mot-clé entre la 1ère et la 50ème position",
        "siteAge": "Date d'ajout du site",
        "themeorglobal": "Site généraliste ou thématique",
        "thesite": "Le site",
        "url": "L'url du lien à placer",
        "urlindice": "Indice",
        "withoutVAT": "HT",
        "yourposition": "Votre position",
        "yourpositionbyurl": "vos positions actuelles par url",
        "yoursite": "Votre site",
        "yoururl": "Votre url"
    },
    "thematique": {
        "exactsearch": "Recherche exacte",
        "lastlogin": "Depuis votre dernière connexion le ",
        "searchkeyword": "Rechercher mot clé",
        "title": "Thématique",
        "typekeyword": "Tapez un mot clé"
    },
    "wordpress_modal": {
        "title": "Configuration plugin Wordpress",
        "wordpress_api_key": "API Token",
        "check_button": "Tester la connexion & sauvegarder",
        "success": "Token valide",
        "getInfos": "Récupération des informations",
        "getAuthors": "Récupération des auteurs",
        "getCategories": "Récupération des catégories",
        "postArticles": "Publication d'un article"
    },
    "config": {
        "mails_nouveau_site_partenaire": "Nouveau site partenaire",
        "mails_demande_retrait_gains": "Demande de retrait",
        "mails_refus_commande_accompagnement": "Refus commande Accompagnement",
        "mails_acceptation_commande": "Acceptation commande",
        "mails_demande_accompagnement": "Demande d'accompagnement",
        "mails_modification_demande_accompagnement": "Modification de demande d'accompagnement",
        "mails_achat_mot_cle_exact_precommande": "Achat mot-clé exact précommande",
        "mails_achats_credits_virement": "Achat de crédit par virement",
        "mails_delai_publication_depasse": "Délais de publication dépassé",
        "mails_demande_suppression_compte": "Demande de suppression de compte",
        "email_notifications_attestations": "Notification d'ajout de document fiscal",
        "admin_bulk_notif_delete": "Suppression de site(s) par un partenaire",
        "admin_bulk_notif_desactivate": "Désactivation de site(s) par un partenaire",
        "redactor_admins_ids": "Rédacteurs administrateurs",
        "redactor_corrector_ids": "Correcteurs",
        "management_nl_ids": "Gestion NL"
    },
    "api": {
        "getKeywordsByStatId": {
            "numberPlacedKeywords": "Liste des Mots Clés placés sur l'URL",
            "seeMoreKeywords": "Voir plus de mots clés"
        }
    },
    "redactor": {
        "title": "Redactor",
        "redactors": "Rédacteurs",
        "nbWordsWriter": "Nombre de mots par jour",
        "nbWordsWrittenToday": "Nombre de mots rédigés aujourd'hui",
        "price": "Prix",
        "title-tab-redactor": "Stats rédacteurs",
        "title-tab-orders": "Commandes à traiter",
        "bought-keywords": "Mot-clé acheté",
        "nbWords": "Nombre de mots",
        "link-anchors": "Liens / ancres",
        "start-writing": "Je commence à rédiger",
        "daily-words-quota": "Vous avez rédigé votre quotat de mots journalier",
        "no-orders": "Aucune commande",
        "orders-processed": "Commandes à traiter",
        "preorders-processed": "Précommandes à traiter",
        "customer-page": "Page client",
        "click-go-site": "Cliquez ici pour vous rendre sur le site",
        "website-title": "Titre",
        "website-meta": "Méta title",
        "actual-content": "Contenu actuel de la page",
        "publish-partner": "Envoyer au partenaire",
        "publish-wordpress": "Publier via le plugin",
        "anchor-saved": "La nouvelle ancre a bien été enregistrée",
        "anchor-edit": "Je modifie l'ancre",
        "anchor-old": "Ancienne ancre",
        "anchor-new": "Nouvelle ancre",
        "anchor-confirm": "Confirmer la nouvelle ancre",
        "content": "Contenu",
        "publishdate": "Date de publication",
        "refuse": "Je refuse",
        "refusals": "Sujets refusés",
        "recap-infos": "Récapitulatif des infos principales",
        "page": "Page",
        "link": "Lien",
        "select-reason": "Sélectionnez le motif",
        "dont-want": "La commande porte sur un sujet que je ne souhaite pas traiter",
        "dont-know": "La commande porte sur un sujet que je ne maitrise pas",
        "other": "Autre",
        "no-info": "Aucun renseignement",
        "link-anchor-present": "Lien(s) et ancre(s) détectés",
        "summary-activity": "Résumé de l'activité sur la période",
        "from": "À partir de",
        "to": "Jusqu'au",
        "orders-done": "Commandes réalisées",
        "words-done": "Nombre de mots rédigés",
        "earnings": "Gains",
        "words-to-treated": "Nombre de mots à traiter",
        "words-day-redactors": "Nombre de mots quotidien que peuvent faire les rédacteurs",
        "redactor-desactivate": "Rédacteur inactif"
    },
    "writing": {
        "title": "Article à rédiger"
    },
    "crawler": {
        "exceptions": {
            "http_error": "Erreur de communication avec le site",
            "anchor_not_found": "l'ancre n'a pas été trouvée",
            "link_not_found": "Le lien n'a pas été trouvé"
        }
    },
    "select": {
        "errorLoading": "Les résultats ne peuvent pas être chargés.",
        "noResults": "Aucun résultat trouvé.",
        "searching": "Recherche en cours….",
        "inputTooShort": "Saisissez au moins",
        "letter": "caractère"
    },
    "accompagnement": {
        "all": "Tous les accompagnements",
        "status": {
            "a_confirmer": "En attente de validation",
            "a_faire": "À faire",
            "en_cours": "En cours",
            "fait": "Fait",
            "en_attente_credit": "En attente de crédit",
            "en_attente_retour_client": "En attente retour client",
            "termine": "Terminé",
            "non_fait": "Non-fait"
        },
        "followup": {
            "status": {
                "todo": "A faire",
                "in_progress": "En cours",
                "awaiting": "En attente retour client",
                "done": "Fait"
            },
            "thematic": {
                "technical": "Technique",
                "structure": "Structure",
                "content": "Contenu",
                "onsite": "Onsite",
                "netlinking": "Netlinking",
                "report": "Rapport",
                "tree_structure": "Arborescence",
                "analytics": "Analytics",
                "others": "Autres"
            }
        },
        "action": {
            "groups": {
                "positioning": "Besoin de positionnement",
                "structure": "Structure",
                "technical": "Technique",
                "content": "Contenu (editorial et sémantique)",
                "monitoring": "Suivi mensuel"
            },
            "thematics": {
                "positioning": {
                    "audit": "Audit de l'existant",
                    "demand-analyse": "Analyse de la demande et concurrence",
                    "keyword-following": "Suivi des MC issus de l'AS dans Monitorank"
                },
                "structure": {
                    "mapping": "Mapping existant du site",
                    "seo-structure": "Elaboration de l'arborescence SEO",
                    "integration": "Intégration du mapping existant dans l'arborescence",
                    "deployment": "Déploiement de l'arborescence sur le site",
                    "recipe": "Recettage de l'arborescence",
                    "internal-mesh": "Optimisation du maillage interne"
                },
                "technical": {
                    "fix-blocking-factors": "Correction des facteurs bloquants",
                    "optimization": "Optimisation technique (chargement, paramètre…)",
                    "log-analysis": "Analyse de logs",
                    "tracking": "Tracking",
                    "recipe": "Recettage audit"
                },
                "content": {
                    "semantic-analysis": "Analyse sémantique",
                    "brief-creation": "Création de brief de contenu",
                    "recipe": "Recettage sémantique",
                    "production": "Production de contenu en interne"
                },
                "monitoring": {
                    "data": "Monitoring des données (crawl, position, logs...)",
                    "monthly": "Reporting mensuel",
                    "target-meeting": "Rendez-vous du 6ème mois pour Objectifs"
                }
            },
            "status": {
                "todo": "A venir",
                "in_progress": "En cours",
                "awaiting": "En attente",
                "done": "Fait"
            }
        }
    },
    "withdrawal-winnings": {
        "title": "Demandes de Retrait",
        "date": "Date",
        "invoice-name": "Nom Facture",
        "user": "Utilisateur",
        "payment": "Règlement",
        "payment-date": "Date de règlement",
        "payment-info": "Infos Paiement",
        "amount-ht": "Montant HT",
        "amount-ttc": "Montant TTC",
        "type": "Type",
        "validation-error": "Validation Erreur",
        "validation-compta": "Validation Compta",
        "validation-date": "Date de Validation",
        "notes": "Remarques",
        "actions": "Actions"
    },
    "gsc": {
        "chooseSite": "Veuillez choisir votre site",
        "logout": "Se déconnecter de GSC",
        "login": "Se connecter à GSC",
        "positionedKeyword": "Mots clés avec articles positionnés",
        "notPositionedKeyword": "Mots clés sans articles positionnés",
        "preorderKeyword": "Précommander des mots clés",
        "noArticlesGsc": "Aucun article présent sur la GSC ne se positionne pas sur des mots clés de votre URL"
    },
    "date": {
        "months": {
            "january": "janvier",
            "february": "février",
            "march": "mars",
            "april": "avril",
            "may": "mai",
            "june": "juin",
            "july": "juillet",
            "august": "août",
            "september": "septembre",
            "october": "octobre",
            "november": "novembre",
            "december": "décembre"
        }
    },
    "validation": {
        "errors": {
            "amount": "Montant"
        },
        "max": {
            "numeric": "la valeur dépasse le maximum autorisé"
        },
        "string": {
            "too-short": "Le texte est trop court"
        }
    },
    "group-site": {
        "title": "Sites",
        "all": "Tous",
        "lang": {
            "fr": "Français",
            "en": "Anglais"
        },
        "valid-save-site": "Les sites ont été ajoutés et activés",
        "valid-reactive-sites": "Les sites sélectionnés ont été réactivés",
        "valid-active-sites": "Les sites sélectionnés ont été activés",
        "modal": {
            "partner": "Partenaire (laisser vide si le site est un site NextLevel)",
            "urls": "URLs (y compris avec http / https), une par ligne",
            "lang": "Langue",
            "group": "Groupe",
            "type": "Type",
            "redaction": "Rédaction",
            "notes": "Notes",
            "url_sell": "URLs mises en vente",
            "mfa": "Refus MFA concurrent",
            "commission_partner": "% de commission si rédaction partenaire",
            "commission_nextlevel": "% de commission si rédaction NextLevel",
            "price_filter": "Filtre prix : ne faire apparaître que les pages dont le prix de vente est supérieur à",
            "minimum_price": "Prix minimum : les prix seront réhaussés pour atteindre au moins",
            "activate_sites": "Activer les sites",
            "confirm": {
                "activationwebsites-text": "Confirmer l'activation de tous les sites séléctionnés"
            }
        },
        "status": {
            "activated": "Activé",
            "deleted": "Supprimé",
            "validation": "En attente de validation",
            "desactivated": "Désactivé",
            "refused": "Refusé",
            "desactivated_partner": "Désactivé (Partenaire)",
            "amelioration": "Amélioration"
        },
        "table": {
            "status": "Statut",
            "lang": "Lang",
            "url": "URL",
            "group": "Groupe",
            "owner": "Propriétaire",
            "url_concerned": "URL concernées",
            "type": "Type de site",
            "WP": "WP",
            "semrush_keywords": "Mots-clés SEMRush",
            "semrush_var": "VAR Semrush",
            "seobserver_keywords": "Mots-clés SEObserver",
            "seobserver_var": "VAR SEObserver",
            "seobserver_update": "MAJ SEObserver",
            "nl_keywords": "Mots-clés NL",
            "nl_var": "VAR NL",
            "nl_update": "MAJ mots-clés",
            "nb_orders": "NB commandes",
            "validation": "Validation",
            "redaction": "Rédaction",
            "actions": "actions"
        }
    },
    "credits": {
        "title": "Crédits",
        "buy": "Acheter des crédits",
        "invoices": "Mes factures",
        "prefix": "Crédits",
        "amount_before": "Balance avant",
        "amount_after": "Balance après",
        "amount": "Montant",
        "event": "Évènement"
    },
    "restrictions": {
        "scrape_sitemap": "Sitemaps",
        "scrape_whitelist": "Whitelist",
        "scrape_blacklist": "Blacklist",
        "admin_scrape_blacklist": "Blacklist admin"
    },
    "sellingwebsite": {
        "label": {
            "potentialGain": "Gains potentiels",
            "saleable": "URL vendables"
        }
    },
    "paymentTunnel": {
        "payCampaign": "Réglement échéance de campagne",
        "continue": "Continuer",
        "buyCredits": "Achat de crédits",
        "selectCampaign": "Sélectionnez la campagne à régler",
        "bankTransfer": {
            "title": "Virement bancaire"
        }
    }
}
